import * as React from 'react'

import { Flex, Text } from '@chakra-ui/react'

import type { GameState } from './types'
import { GameStateType } from './types'

type Props = {
  state: GameState
}

function getLoadingText(state: GameState) {
  if (state.type === GameStateType.GameError) return 'Load interrupted'
  return 'Preparing arena'
}

export default function StatusOverlay(props: Props) {
  React.useEffect(() => {
    document.getElementById('early-brand-loader')?.remove()
  }, [])

  const { state } = props

  return (
    <Flex
      align="center"
      justify="center"
      minH="100%"
      bg="#05070d"
      color="#ef2828"
      fontFamily="ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace"
    >
      <Text fontSize={{ base: 'lg', md: '2xl' }} letterSpacing="0.08em">
        {getLoadingText(state)}...
      </Text>
    </Flex>
  )
}
